import { useLingui } from '@lingui/react/macro';
import { IconSearch } from 'app-ui/icon';
import { useIsTouchDevice } from 'app-ui/utilities';

import { useOpenCommandMenu } from '@/command-menu/hooks/useOpenCommandMenu';
import { NAVIGATION_ITEMS } from '@/navigation/constants/NavigationItems';
import { NavigationDrawerItem } from '@/ui/layout/navigation-drawer/components/NavigationDrawerItem';
import { NavigationDrawerSection } from '@/ui/layout/navigation-drawer/components/NavigationDrawerSection';
import { HotkeyHint } from '@/ui/utilities/hotkey/components/HotkeyHint';

export const MainNavigation = () => {
  const { t, i18n } = useLingui();
  const { openCommandMenu } = useOpenCommandMenu();
  // Touch screens usually have no keyboard to use the shortcut with.
  const isTouchDevice = useIsTouchDevice();

  return (
    <NavigationDrawerSection>
      <NavigationDrawerItem
        label={t`Search`}
        Icon={IconSearch}
        onClick={openCommandMenu}
        endContent={isTouchDevice ? undefined : <HotkeyHint hotkey="mod+k" />}
      />
      {NAVIGATION_ITEMS.map((navigationItem) => (
        <NavigationDrawerItem
          key={navigationItem.id}
          label={i18n._(navigationItem.label)}
          Icon={navigationItem.Icon}
          to={navigationItem.path}
          end
        />
      ))}
    </NavigationDrawerSection>
  );
};
